"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M16 7.99l-16-6 4 6-4 6z"];
//# sourceMappingURL=direction-right.js.map